import { Component, OnInit, ViewChild } from "@angular/core";
import { ListeComponent } from "../liste/liste.component";
import { DateService } from "../services/date.service";
import { GeneralService } from "../services/general.service";

@Component({
  selector: "app-liste-commandes",
  templateUrl: "./liste-commandes.component.html",
  styleUrls: ["./liste-commandes.component.scss"],
})
export class ListeCommandesComponent implements OnInit {
  constructor(
    public generalService: GeneralService,
    public dateService: DateService
  ) {}
  exist: boolean = false;
  columns = {
    TableRD: [
      {
        TableRE_Code: "",
        TableRD_Champs: "Doc_Num",
        Lg_Code: "",
        TableRD_Des: "Code",
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: "",
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
      {
        TableRE_Code: "",
        TableRD_Champs: "Tiers_code",
        Lg_Code: "",
        TableRD_Des: "Client",
        TableRD_Largeur: 250,
        TableRD_ReadOnly: true,
        TableRD_Format: "",
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
      {
        TableRE_Code: "",
        TableRD_Champs: "Doc_Date",
        Lg_Code: "",
        TableRD_Des: "Date",
        TableRD_Largeur: 90,
        TableRD_ReadOnly: true,
        TableRD_Format: "dd-MM-yyyy",
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
      {
        TableRE_Code: "",
        TableRD_Champs: "Doc_THT",
        Lg_Code: "",
        TableRD_Des: "M.TTC",
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: "",
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
      {
        TableRE_Code: "",
        TableRD_Champs: "Doc_Valide",
        Lg_Code: "",
        TableRD_Des: "État",
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: "",
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 1,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: "*",
        User_Groupe: null,
      },
    ],
  };
  date_Debut: Date;
  date_Fin: Date;
  nomFenetre: string;
  @ViewChild("listeDocumentComponen") listeDocumentComponen: ListeComponent;
  listeDocument = [];
  client = null;
  commande = [];
  showDetail: boolean = false;
  ngOnInit() {
    this.client = {};
    this.init();
  }
  init() {
    this.exist = false;
    this.initDate();
    this.getListeDocument();
    this.fraisLivraison();
  }
  initDate() {
    this.date_Debut = new Date();
    this.date_Debut.setMonth(this.date_Debut.getMonth() - 2);
    this.date_Debut.setDate(1);
    this.date_Fin = new Date();
  }

  getListeDocument() {
    this.exist = false;
    var url = this.getUrl();
    //
    this.generalService.rechercheTable(url).subscribe(
      (listeDocument) => {
        this.listeDocument = listeDocument.sort((a, b) =>
          a.Doc_Num < b.Doc_Num ? 1 : b.Doc_Num < a.Doc_Num ? -1 : 0
        );
        this.listeDocument.forEach((doc) => {
          if (doc.Doc_Valide == 1) doc.Doc_Valide = true;
          else doc.Doc_Valide = false;
          // doc.Doc_THT =doc.Doc_Num
          this.generalService
            .rechercheTable(
              "recherche/tbdata?tablere=ecDoc&param=" + doc.Tiers_code
            )
            .subscribe((data) => {
              let cmd = data.filter((cm) => {
                return cm.Doc_Num == doc.Doc_Num;
              });
              if (this.generalService.cuurentUser != "SNCT")
                doc.Doc_THT = this.total(cmd).toFixed(3);
              else {
                console.log("doc", doc);
                console.log("cmd", cmd);

                console.log(this.getFraisSNCT(cmd, doc, this.somme(cmd)));

                doc.Doc_THT = (
                  this.total(cmd) + this.getFraisSNCT(cmd, doc, this.somme(cmd))
                ).toFixed(3);
              }
            });
        });
        console.log(listeDocument);

        this.listeDocumentComponen.setDataSource(listeDocument);
        this.exist = true;
      },
      () => {
        this.exist = true;
      }
    );
  }
  getFraisSNCT(cmd, doc, poidsTotal) {
    if (doc.Doc_Param1 == "1") {
      let hasZero = false;
      console.log(this.commande);
      cmd.forEach((art) => {
        if (art.DocD_Transport == 0) hasZero = true;
      });

      var prixLiv = this.frais.find(
        (element) =>
          poidsTotal >= element.PoidsMin && poidsTotal <= element.PoidsMax
      );
      console.log(prixLiv);

      if ((prixLiv != null || prixLiv != undefined) && !hasZero)
        return prixLiv.Liv;
      else return 0;
    } else return 0;
  }
  getUrl() {
    var url = this.generalService.url + "avtdoc&param=";
    url +=
      "CMD," +
      this.dateService.setFormatDateRechercheServer(this.date_Debut) +
      "," +
      this.dateService.setFormatDateRechercheServer(this.date_Fin);

    return url;
  }
  affichierDetailCommande() {
    this.getClient();
  }
  poid;
  showFrais;
  getClient() {
    this.generalService
      .rechercheTable(
        "ds/formdata?code=client&val=" +
          this.listeDocumentComponen.row.Tiers_code
      )
      .subscribe((data) => {
        this.client = data.Tiers[0];
        this.showDetail = true;
      });
    this.generalService
      .rechercheTable(
        "recherche/tbdata?tablere=ecDoc&param=" +
          this.listeDocumentComponen.row.Tiers_code
      )
      .subscribe((data) => {
        this.commande = data.filter((cm) => {
          return cm.Doc_Num == this.listeDocumentComponen.row.Doc_Num;
        });
        this.poid = this.somme(this.commande);
      });
  }
  total(tab) {
    var sum = 0;
    tab.forEach((element) => {
      sum += element.DocD_PUHTN * element.DocD_Q;
    });
    return sum;
  }
  somme(tab) {
    var sum = 0;
    tab.forEach((element) => {
      sum += element.DocD_PoidsU * element.DocD_Q;
    });
    console.log(sum);
    return sum;
  }
  fraisLivraisonBigDar() {
    let sum = 0;
    console.log(this.commande);
    console.log(this.frais);
    this.commande.forEach((art) => {
      sum += art?.DocD_Transport;
    });
    return sum;
  }
  hasZeroValue() {
    console.log(this.commande);
    let hasZero = false;
    this.commande.forEach((art) => {
      if (art.DocD_PoidsU == 0) hasZero = true;
    });
    return hasZero;
  }
  transportZero() {
    let hasZero = false;
    console.log(this.commande);
    this.commande.forEach((art) => {
      if (art.DocD_Transport == 0) hasZero = true;
    });
    return hasZero;
  }
  Frais(poidsTotal) {
    console.log(poidsTotal);
    console.log(this.frais);
    var prixTotal = this.total(this.commande);
    var prixLiv = this.frais.find(
      (element) =>
        poidsTotal >= element.PoidsMin &&
        poidsTotal <= element.PoidsMax &&
        prixTotal >= element.ValMin &&
        prixTotal <= element.ValMax
    );
    console.log(prixTotal);
    console.log(poidsTotal);
    console.log(prixLiv);
    if (prixLiv) {
      return prixLiv.Liv;
    }
  }
  fraisLiv(poidsTotal) {
    var frais = this.Frais(poidsTotal);
    console.log(frais);
    console.log(this.transportZero());
    if (frais >= 0) {
      console.log(frais);
      return frais;
    } else {
      return "Sur demande";
    }
  }

  getTotal() {
    return (
      this.commande.reduce((accumulateur, valeurCourante) => {
        return accumulateur + valeurCourante.DocD_PUHTN * valeurCourante.DocD_Q;
      }, 0) + this.getValueFrais(this.poid)
    ).toFixed(3);
  }
  frais;
  fraisLivraison() {
    this.generalService
      .rechercheTable("recherche/tbdata?tablere=FraisLiv")
      .subscribe((data: any) => {
        console.log(data);
        this.frais = data;
      });
  }
  getValueFrais(poidsTotal) {
    console.log(poidsTotal);
    console.log(this.transportZero());
    if (
      this.lastDoc?.Doc_Param1 == "1" &&
      !this.hasZeroValue() &&
      !this.transportZero()
    ) {
      console.log("**8888***");
      var frais = this.Frais(poidsTotal);
      console.log(frais);
      if (frais) return frais;
      else {
        return 0;
      }
    } else return 0;
    /* if (poidsTotal > 0 && poidsTotal <= 10) {
       return 8;
     } else if (poidsTotal > 0 && poidsTotal <= 25) {
       return 13;
     } else if (poidsTotal > 0 && poidsTotal < 40) {
       return 45;
     } else return 0;
   } else return 0;*/
  }
  clickBtnHeat(event) {
    console.log(event);
    this.getds(event.row?.Doc_Num);
    switch (event.name) {
      case "selectRow": {
        this.affichierDetailCommande();
        break;
      }
    }
  }
  lastDoc;
  document;
  getds(id) {
    this.generalService
      .rechercheTable("ds/formdata?code=document&val=" + id)
      .subscribe((res: any) => {
        this.lastDoc = res.Document[0];
        console.log(res);
      });
  }
  saveStateCommande(event) {
    this.generalService
      .rechercheTable("ds/formdata?code=document&val=" + event.row.Doc_Num)
      .subscribe((data) => {
        data.Document[0].Doc_Valide = event.row.Doc_Valide ? 1 : 0;
        this.generalService.enregisterTable(data).subscribe(() => {
          this.generalService.dialogSuccess("Enregistrer", true);
        });
      });
  }
  outputActionListeHeurSemaineComponent(event) {
    switch (event.action) {
      case "onCheckboxChange": {
        this.saveStateCommande(event);
        break;
      }
    }
  }
}
